var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 240,
    viewBox: "0 0 200 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M139.67 49.24C134.203 49.2347 128.961 47.0606 125.095 43.1947C121.229 39.3288 119.055 34.0871 119.05 28.62V0H26.91C19.7748 -4.92665e-07 12.9316 2.83379 7.88528 7.87823C2.83897 12.9227 0.00265152 19.7648 0 26.9V189.12C0.0079507 196.252 2.84661 203.089 7.89235 208.129C12.9381 213.169 19.7782 216 26.91 216H137.51C141.045 216.001 144.545 215.306 147.811 213.954C151.077 212.603 154.045 210.621 156.545 208.122C159.045 205.623 161.028 202.656 162.381 199.39C163.734 196.125 164.43 192.625 164.43 189.09V49.24H139.67Z",
    fill: "#FF3E4C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.43 49.24H139.67C134.203 49.2347 128.961 47.0606 125.095 43.1947C121.229 39.3288 119.055 34.0871 119.05 28.62V0L164.43 49.24Z",
    fill: "#FF3E4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.94 170.6H58.9C50.0303 170.6 42.84 177.79 42.84 186.66V223.94C42.84 232.81 50.0303 240 58.9 240H183.94C192.81 240 200 232.81 200 223.94V186.66C200 177.79 192.81 170.6 183.94 170.6Z",
    fill: "#FF3E4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7 213.37V220.64H65.18V213.37H72.7Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.93 220.64L85.42 209.29H83.76V220.64H76.49V190.57H88.91C90.9792 190.512 93.0334 190.936 94.91 191.81C96.4543 192.54 97.7434 193.718 98.61 195.19C99.4473 196.689 99.8718 198.383 99.84 200.1C99.8964 202.108 99.2609 204.075 98.04 205.67C96.6937 207.285 94.8393 208.395 92.78 208.82L100 220.64H91.93ZM83.76 204.31H88.27C89.422 204.397 90.5635 204.039 91.46 203.31C91.8154 202.936 92.0881 202.492 92.2604 202.006C92.4327 201.521 92.5007 201.004 92.46 200.49C92.4938 199.978 92.4225 199.465 92.2505 198.982C92.0786 198.498 91.8095 198.055 91.46 197.68C90.5768 196.941 89.4373 196.582 88.29 196.68H83.78L83.76 204.31Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.17 215.16H110.9L109 220.64H101.34L112.34 190.79H120.72L131.72 220.64H124L122.17 215.16ZM120.3 209.63L116.56 198.57L112.77 209.63H120.3Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.46 190.57L168.28 220.64H159.28L154.47 200.53L149.62 220.64H140.62L133.43 190.57H141.34L145.21 212.35L150.48 190.57H158.48L163.75 212.35L167.66 190.57H175.46Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.34 123.66H41.06C39.1607 118.658 38.1915 113.351 38.2 108C38.1927 102.653 39.1619 97.349 41.06 92.35C41.8159 90.3706 42.715 88.4488 43.75 86.6L47.1 92.35L56.29 108.12L60.29 115.06L65.34 123.66Z",
    fill: "#FF3E4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.32 135.84C109.577 144.108 100.06 149.645 89.54 151.42C87.3216 151.788 85.0786 151.989 82.83 152.02L86.37 146.02L95.37 130.66L99.45 123.66L104.45 115.1L109.35 123.66L113.35 130.66L116.32 135.84Z",
    fill: "#FF3E4C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126.23 108C126.239 113.348 125.266 118.653 123.36 123.65C122.604 125.639 121.705 127.571 120.67 129.43L117.37 123.65L108.51 108.18L104.51 101.18L99.43 92.3101H123.33C125.251 97.3178 126.234 102.636 126.23 108Z",
    fill: "#FF3E4C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120 85.41H77.32L82.41 76.53L86.41 69.53L89.26 64.53C100.057 66.2715 109.816 71.9765 116.63 80.53C117.862 82.0787 118.988 83.709 120 85.41Z",
    fill: "#FF3E4C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.57 64L78.4 69.53L69.31 85.41L65.31 92.41L60.31 101.22L55.17 92.41L51.17 85.41L48.17 80.23C55.0495 71.7602 64.8343 66.1531 75.62 64.5C77.5899 64.2002 79.5777 64.0331 81.57 64Z",
    fill: "#FF3E4C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.32 130.62L82.32 139.08L78.32 145.96L75.11 151.46C64.6061 149.742 55.0811 144.274 48.3 136.07C46.8804 134.351 45.5902 132.53 44.44 130.62H87.32Z",
    fill: "#FF3E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaw);
export default __webpack_public_path__ + "static/media/RAW.fd98e3b7b773edd8bf49ed69098c1339.svg";
export { ForwardRef as ReactComponent };